//视频加载进度监听函数-------------------------------
/**
 * 监听视频缓冲进度是否超过指定比例
 * @param {HTMLVideoElement} video - 视频元素
 * @param {number} threshold - 比例阈值 (0~1)，例如 1/3
 * @param {Function} callback - 达标时执行的回调
 * @param {boolean} once - 是否只触发一次，默认 true
 */
function onBufferProgress(video, threshold, callback, once = true) {
  // 确保视频元数据已加载，duration 可用
  function check() {
    if (!video.duration || !isFinite(video.duration)) return false;
    if (video.buffered.length === 0) return false;

    const bufferedEnd = video.buffered.end(video.buffered.length - 1);
    return (bufferedEnd / video.duration) > threshold;
  }

  // 元数据加载完成后才开始监听
  function startListening() {
    // 立刻检查一次，因为可能已经缓冲够了（例如预加载）
    if (check()) {
      callback();
      if (once) return; // 只触发一次则不再继续
    }

    // 监听 progress 事件
    function onProgress() {
      if (check()) {
        callback();
        if (once) {
          video.removeEventListener('progress', onProgress);
        }
      }
    }

    video.addEventListener('progress', onProgress);
  }

  if (video.readyState >= 1) {
    // 元数据已经加载了
    startListening();
  } else {
    video.addEventListener('loadedmetadata', startListening, { once: true });
  }
}

// 应用实例------------------------
// const video = document.querySelector('video');

// // 监听进度首次超过 1/3，只触发一次
// onBufferProgress(video, 1 / 3, () => {
//   console.log('视频已加载超过 1/3，可以开始一些操作了');
// });

// // 如果想每次都触发（例如更新 UI），将 once 设为 false
// onBufferProgress(video, 1 / 3, () => {
//   console.log('当前缓冲进度仍然超过 1/3');
// }, false);

// 预加载图片------------------------------------
function preloadImage(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error(`Failed to load image: ${url}`));
    img.src = url;
  });
}

async function preloadImagesWithPromise(urls, onProgress) {
  let loaded = 0;
  const total = urls.length;

  // 每个图片加载后更新进度
  const loadPromises = urls.map(async (url) => {
    try {
      const img = await preloadImage(url);
      loaded++;
      onProgress && onProgress(loaded, total, url);
      return img;
    } catch (err) {
      loaded++;
      onProgress && onProgress(loaded, total, url, true);
      throw err; // 如果需要整体失败，可重新抛出
    }
  });

  try {
    const images = await Promise.all(loadPromises);
    return images; // 所有图片加载成功
  } catch (err) {
    console.error('预加载过程中有图片失败', err);
    // 可处理部分失败的情况
  }
}

// 使用示例
// const urls = ['1.jpg', '2.jpg', '3.jpg'];
// preloadImagesWithPromise(urls, (loaded, total, url, error) => {
//   console.log(`${loaded}/${total}`, error ? '❌' : '✅', url);
// }).then(images => {
//   console.log('全部完成', images);
// });

// ------------图片预加载简化版，不阻塞主进程--------------------------------------------------
const preloadedSet = new Set();
function preloadSilently(urls) {
  if (typeof urls === 'string') urls = [urls];
  urls.forEach(url => {
    if (preloadedSet.has(url)) {//去重处理，对于已加载过的，直接返回
      // console.log(`⏭️ 图片已预加载，跳过：${url}`)
      return;
    } 
    const img = new Image();
    img.src = url;
    preloadedSet.add(url);
  });
}

// 使用示例-------------

// // 1. 先预加载
// const preloadUrl = (['page4.jpg', 'page5.jpg']);
// preloadSilently(preloadUrl);

// // 2. 过了一段时间（比如点击按钮或 Swiper 滑动结束），直接把 URL 赋给真正的 img
// document.getElementById('main-image').src = preloadUrl[0];
// // 此时浏览器会从缓存中瞬间读取，肉眼几乎看不到加载过程


// 滚动加载----------------------------------------------------------
// 获取元素相对于文档顶部的真实距离
function getOffsetTop(element) {
  let top = 0;
  while (element) {
    top += element.offsetTop;
    element = element.offsetParent;
  }
  return top;
}

// 判断元素是否距离视口底部（或顶部）小于等于 distance 像素
function isNearViewport(element, distance = 200) {
  const rect = element.getBoundingClientRect();
  // 只要元素顶部或底部进入“视口扩大 distance 像素”的区域就算接近
  return rect.top - distance <= window.innerHeight && rect.bottom + distance >= 0;
}

// 节流函数（保证滚动事件每秒最多执行几次，提升性能）
function throttle(fn, delay = 200) {
  let timer = null;
  return function(...args) {
    if (timer) return;
    timer = setTimeout(() => {
      fn.apply(this, args);
      timer = null;
    }, delay);
  };
}
function getElement(selector) {
  // 优先当作 id 处理（因为 id 唯一，且 id 选择器更快）
  let el = document.getElementById(selector);
  if (el) return el;
  // 其次当作 class 处理
  const classEls = document.getElementsByClassName(selector);
  return classEls.length ? classEls[0] : null;
}

// 懒加载主逻辑
function lazyload(sectionSelector, targetSelector, src, offset = 200) {
  const section = getElement(sectionSelector);
  const target = getElement(targetSelector);
  if (!section || !target) return;
  
  // 判断区域是否接近视口
  if (isNearViewport(section, offset) && !target.src) {
    target.src = src;
  }
}
// 懒加载背景图
function lazyloadBGimg(sectionSelector, targetSelector, src, offset = 200) {
  const section = getElement(sectionSelector);
  const target = getElement(targetSelector);
  if (!section || !target) return;
  
  // 判断区域是否接近视口
  if (isNearViewport(section, offset) && !target.style.backgroundImage) {
     target.style.backgroundImage = `url(${src})`;
  }
}
// 使用示例：监听滚动（页面加载时绑定一次）
// const lazyHandler = throttle(() => {
//   lazyload('.section1', '.lazy-img1', 'https://example.com/1.jpg', 200);
//   lazyload('#section2', '#lazy-video', 'https://example.com/video.mp4', 250);
//   // 可以继续添加多个...
// }, 200);

// window.addEventListener('scroll', lazyHandler);
// // 立即执行一次，防止首屏未滚动时漏加载
// lazyHandler();


// ========== 核心：基于 Intersection Observer 的懒加载管理器,性能比 lazyload 监听滚动好很多 ==========++++++
function getElement(selector) {
  let el = document.getElementById(selector);
  if (el) return el;
  const classEls = document.getElementsByClassName(selector);
  return classEls.length ? classEls[0] : null;
}

function createLazyLoader(items = [], autoObserve = true, defaultOffset = 200) {
  let observer = null;
  const elementMap = new WeakMap();          // key: section元素, value: { element, src, poster }
  const sectionSet = new Set();              // 存储所有 section 元素（用于迭代）

  // 加载单个媒体
  function loadMedia(target, src, poster) {
    if (!target) return;
    const tag = target.tagName;
    if (tag === 'IMG') {
      if (src && target.src !== src) {
        target.src = src;
        target.classList.add('loaded');
      }
    } else if (tag === 'VIDEO') {
      if (poster && target.poster !== poster) {
        target.poster = poster;
      }
      if (src && target.src !== src) {
        target.src = src;
        target.load();
        target.classList.add('loaded');
      }
    }
  }

  // Intersection Observer 回调
  function handleIntersect(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const data = elementMap.get(entry.target);
        if (data) {
          // [NEW] 支持 srcset
          const target = data.element;
          if (target.tagName === 'IMG' && data.srcset) {
            if (target.srcset !== data.srcset) {
              target.srcset = data.srcset;
              target.classList.add('loaded');
            }
          }
          loadMedia(data.element, data.src, data.poster);
          observer.unobserve(entry.target);
          sectionSet.delete(entry.target); // 从集合中移除（已加载）
        }
      }
    });
  }

  // 创建/重建 Observer，使用当前所有 section 中的最大 offset
  function buildObserver() {
    if (observer) observer.disconnect();
    // 收集所有 section 对应的 offset
    let maxOffset = defaultOffset;
    for (const section of sectionSet) {
      const data = elementMap.get(section);
      if (data && data.offset > maxOffset) {
        maxOffset = data.offset;
      }
    }
    observer = new IntersectionObserver(handleIntersect, {
      root: null,
      rootMargin: `0px 0px ${maxOffset}px 0px`,
      threshold: 0
    });
    // 观察所有 section
    for (const section of sectionSet) {
      observer.observe(section);
    }
  }

  // 添加单个配置
  function add(item) {
    const section = getElement(item.section);
    const target = getElement(item.target);
    if (!section || !target) {
      console.warn(`无效配置: section=${item.section}, target=${item.target}`);
      return;
    }
    // 如果已经存在，先移除旧的观察
    if (sectionSet.has(section)) {
      if (observer) observer.unobserve(section);
      sectionSet.delete(section);
    }
    // 存储数据
    elementMap.set(section, {
      element: target,
      src: item.src || null,
      poster: item.poster || null,
      srcset: item.srcset || null,   
      offset: item.offset || defaultOffset
    });
    sectionSet.add(section);
    // 如果 observer 已存在，重建（因为可能 offset 变化）
    if (observer) {
      buildObserver();
    }
  }

  // 批量添加
  function addItems(newItems) {
    newItems.forEach(item => add(item));
    if (!observer && sectionSet.size > 0) {
      buildObserver();
    }
  }

  // 启动观察（如果尚未启动）
  function start() {
    if (observer) return;
    if (sectionSet.size === 0) {
      console.warn('没有配置任何懒加载项');
      return;
    }
    buildObserver();
  }

  // 停止观察
  function stop() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }

  // 销毁（清理所有）
  function destroy() {
    stop();
    // 清除所有记录（但 WeakMap 无法清空，只能重置引用，但这里无法在闭包中重置，只能清空 Set）
    sectionSet.clear();
    // elementMap 中的条目会在 section 被垃圾回收时自动释放，无需手动清理
  }

  // 初始化
  if (items.length && autoObserve) {
    addItems(items);
    start();
  } else if (items.length && !autoObserve) {
    addItems(items);
  }

  return { add, addItems, start, stop, destroy };
}

// ========== 初始化 ==========
function initLazyLoad(items, defaultOffset = 200) {
  return createLazyLoader(items, true, defaultOffset);
}

// 使用实例
// const lazyItems = [
//   { section: 'section1', target: 'img1', src: 'https://example.com/photo.jpg', offset: 200 },
//   { section: 'section2', target: 'video1', src: 'https://example.com/video.mp4', poster: 'https://example.com/poster.jpg', offset: 250 } //如果需要传参视频封面的情况
// ];

// const loader = initLazyLoad(lazyItems);
// 动态添加新的项
// loader.add({ section: 'section3', target: 'img2', src: '...' });



/**
 * 检测图片加载状态（支持缓存）-------------------------------------------
 * @param {HTMLImageElement} imgElement - 目标img元素
 * @returns {Promise<boolean>} true=加载成功, false=加载失败
 */
function waitImageLoaded(imgElement) {
  return new Promise((resolve) => {
    // 如果 complete 为 true，说明图片已经加载完毕（无论成功或失败）
    if (imgElement.complete) {
      // 判断是否是有效图片（自然宽度 > 0）
      resolve(imgElement.naturalWidth > 0);
      return;
    }

    // 2. 如果 complete 为 false，绑定事件监听
    const onLoad = () => {
      resolve(true);
      cleanup();
    };
    const onError = () => {
      resolve(false);
      cleanup();
    };
    const cleanup = () => {
      imgElement.removeEventListener('load', onLoad);
      imgElement.removeEventListener('error', onError);
    };

    imgElement.addEventListener('load', onLoad);
    imgElement.addEventListener('error', onError);
  });
}

// 使用示例
// const img = document.querySelector('img');
// waitImageLoaded(img).then((success) => {
//   if (success) {
//     console.log('图片加载完成，可以移除骨架屏动画了');
//     img.classList.add('loaded'); // 配合CSS隐藏背景渐变
//   } else {
//     console.log('图片加载失败，显示破图占位符');
//   }
// });


/**
 * ------------------------------------------------------------
 * 精确获取屏幕物理等级 (基于水平物理像素)
 * 标准：1K(FHD) / 2K(QHD) / 4K(UHD) / 8K及以上
 * ------------------------------------------------------------
 */

// (1) 获取物理分辨率的底层方法
function getAccurateScreenInfo() {
  // 防御 SSR 及非浏览器环境
  if (typeof window === 'undefined' || !window.screen) {
    return { physicalWidth: 0, physicalHeight: 0, dpr: 1 };
  }

  // 关键点：必须使用 Math.round，因为部分浏览器（如安卓）DPR 可能为 2.625
  const dpr = window.devicePixelRatio || 1;
  const physicalWidth = Math.round(window.screen.width * dpr);
  const physicalHeight = Math.round(window.screen.height * dpr);

  return {
    physicalWidth,
    physicalHeight,
    logicalWidth: window.screen.width,
    logicalHeight: window.screen.height,
    dpr: dpr
  };
}

// (2) 核心判断函数（支持自定义阈值，适应不同行业标准）
function getScreenCategory(customThresholds) {
  // 定义权威阈值（基于消费级显示器常规标准）
  const defaultThresholds = {
    LOW: 1800,    // 低于此值：老旧低分屏（1366x768, 1600x900）
    FHD: 2300,    // 1920x1080 归属 FHD；2560x1440 归属 2K
    QHD: 3000,    // 2560x1440 归属 2K；3840x2160 归属 4K
    UHD: 6000     // 3840x2160 归属 4K；7680x4320 归属 8K
  };

  const { LOW, FHD, QHD, UHD } = { ...defaultThresholds, ...customThresholds };
  const info = getAccurateScreenInfo();
  const { physicalWidth, physicalHeight } = info;

  // 容错：若获取失败
  if (physicalWidth === 0) {
    return { ...info, category: 'undefuned', level: 0 };
  }

  // 区间判定（严格从大到小，防止超宽屏误判）
  let category = '其它';
  let level = 0; // 用于业务排序

  if (physicalWidth >= UHD) {
    category = '8K';
    level = 4;
  } else if (physicalWidth >= QHD && physicalWidth < UHD) {
    category = '4K';
    level = 3;
  } else if (physicalWidth >= FHD && physicalWidth < QHD) {
    category = '2K';
    level = 2;
  } else if (physicalWidth >= LOW && physicalWidth < FHD) {
    category = '1K ';
    level = 1;
  } else {
    category = 'other';
    level = 0;
  }

  return {
    ...info,
    category,
    level,          // 数值等级，方便 if (level > 2) 判断高清屏
    displayName: `${category} (${physicalWidth}×${physicalHeight})`
  };
}

//使用案例
// const screen = getScreenCategory();
  
// let imageUrl = '';
// // 根据等级选择最佳素材（节约流量并保证清晰度）
// switch (screen.category) {
//   case '8K':
//     imageUrl = 'https://cdn.example.com/bg-8k.jpg';
//     break;
//   case '4K':
//     imageUrl = 'https://cdn.example.com/bg-4k.jpg';
//     break;
//   case '2K':
//     imageUrl = 'https://cdn.example.com/bg-2k.jpg';
//     break;
//   default: // 1K 和 其它
//     imageUrl = 'https://cdn.example.com/bg-fhd.jpg';
//     break;
// }